export const REPORT_GET_ALL = "REPORT_GET_ALL";
export const REPORT_GET_ALL_SKILLS = "REPORT_GET_ALL_SKILLS";
export const REPORT_GET_LEADS = "REPORT_GET_LEADS";
export const REPORT_GET_CANDIDATES = "REPORT_GET_CANDIDATES";
export const REPORT_GET_CRM_ACCOUNTS = "REPORT_GET_CRM_ACCOUNTS";
export const REPORT_GET_SOCIAL_ACCOUNTS = "REPORT_GET_SOCIAL_ACCOUNTS";
export const REPORT_GET_CRM_ORGANIZATION = "REPORT_GET_CRM_ORGANIZATION";
export const REPORT_GET_SOCIAL_ORGANIZATION = "REPORT_GET_SOCIAL_ORGANIZATION";